module.exports = __webpack_public_path__ + "media/2.6dd25e33.mp3";